var _guid = 1;
export function newGUID() {
    return _guid++;
}